module.exports = __webpack_public_path__ + "a08ab204b99e74b20a754b5bd85583f9.png";